module.exports = "<section class=\"row no-margin h-100\">\n  <iframe class=\"iframe\" [src]=\"safeUrl\" frameborder=\"0\" allowfullscreen></iframe>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/configuracion/configuracion.component.html
// module id = ../../../../../src/app/pages/admin/configuracion/configuracion.component.html
// module chunks = main